import styled from 'styled-components'

const defaultProps = {
  padding: '15.5px 10px',
  backgroundColor: '#333',
  color: '#999',
  backgroundColorHover: '#262626',
  colorHover: '#bfbfbf'
}

const SearchBtn = styled.button`
  float: right;
  height: var(--search-input-height);
  width: 12%;
  background-color: ${props => props.backgroundColor};
  color: ${props => props.color};
  padding: ${props => props.padding};
  border: 0;
  border-radius: 4px;
  transition: all 0.3s ease;

  &:hover,
  &:focus {
    background-color: ${props => props.backgroundColorHover};
    color: ${props => props.colorHover};
  }
`

SearchBtn.defaultProps = defaultProps
export default SearchBtn



// WEBPACK FOOTER //
// ./src/components/SearchBtn/index.js